import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@auth/auth.service';
import { environment } from '@environments/environment';
import { LocalService } from '@home/storage/local.service';
import { Payload } from '@model/asopagos/payload';
import RedirectRequestPayment from '@model/redirect-request-payment';
import { generateUniqueUID } from '@shared/utility/generate-uid';
import { Observable } from 'rxjs';
import { CommandResponseType } from '../config';

@Injectable({
  providedIn: 'root',
})
export class ExtendTermService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly authenticationService: AuthService,
    private readonly localService: LocalService
  ) {}

  public command({
    loanId,
    term,
    novationType,
  }: {
    loanId: number;
    term?: number;
    novationType?: string;
  }): Observable<CommandResponseType> {
    const token = this.localService.getJsonValue('token');
    const payloadClient: Payload = this.authenticationService.getTokenData(token);
    return this.httpClient.post<CommandResponseType>(`${environment.apiBackDebtUrl}command`, {
      name: 'cmd.novate-pending-state.update',
      version: '1.0',
      traceability: {
        provenance: 'RP-Cliente',
        module: 'Novation',
        requestId: generateUniqueUID({ loanId } as RedirectRequestPayment, 'RP-Cliente'),
        requestTime: new Date().getTime(),
      },
      businessData: {
        customer: payloadClient.clienteId,
      },
      payload: {
        loanCode: loanId,
        term: term,
        novationType: novationType,
      },
    });
  }
}
